/** @internal */
export const OP_CONTINUE = "Continue";
/** @internal */
export const OP_CLOSE = "Close";
/** @internal */
export const OP_YIELD = "Yield";
//# sourceMappingURL=channelChildExecutorDecision.js.map